module.exports = __webpack_public_path__ + "static/img/icon_bg2_zh.a3a8890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bg2_zh.png
// module id = +kDy
// module chunks = 0